import React from 'react';

const FinalCallToAction = () => {
  return (
    <section className="py-16 px-4 md:px-8 lg:px-16 bg-gradient-to-br from-dark-2 to-blue-2 text-white">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold mb-6 font-sans">
          Choisissez la formule qui correspond à votre école et embarquez vos élèves dans l'aventure Little Maker.
        </h2>
        <p className="text-light-3 text-xl mb-10 font-sans max-w-3xl mx-auto">
          Rejoignez les centaines d'établissements qui ont déjà transformé leur approche pédagogique avec nos solutions innovantes.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          <div className="bg-dark-5 bg-opacity-50 rounded-2xl p-6 hover:bg-opacity-70 transition-all duration-300">
            <div className="text-3xl mb-4">📋</div>
            <h3 className="text-lg font-semibold mb-3 font-sans">Demander un devis</h3>
            <p className="text-light-3 text-sm font-sans mb-4">
              Obtenez une estimation personnalisée pour votre établissement
            </p>
            <button className="w-full bg-red-4 hover:bg-red-600 text-white font-sans font-medium py-3 px-6 rounded-full transition-colors duration-300">
              Devis personnalisé
            </button>
          </div>

          <div className="bg-dark-5 bg-opacity-50 rounded-2xl p-6 hover:bg-opacity-70 transition-all duration-300">
            <div className="text-3xl mb-4">📘</div>
            <h3 className="text-lg font-semibold mb-3 font-sans">Télécharger la brochure</h3>
            <p className="text-light-3 text-sm font-sans mb-4">
              Découvrez tous nos programmes en détail (PDF 12 pages)
            </p>
            <button className="w-full bg-red-4 hover:bg-red-600 text-white font-sans font-medium py-3 px-6 rounded-full transition-colors duration-300">
              Télécharger
            </button>
          </div>

          <div className="bg-dark-5 bg-opacity-50 rounded-2xl p-6 hover:bg-opacity-70 transition-all duration-300">
            <div className="text-3xl mb-4">👥</div>
            <h3 className="text-lg font-semibold mb-3 font-sans">Prendre rendez-vous</h3>
            <p className="text-light-3 text-sm font-sans mb-4">
              Échangez avec notre équipe pédagogique
            </p>
            <button className="w-full bg-red-4 hover:bg-red-600 text-white font-sans font-medium py-3 px-6 rounded-full transition-colors duration-300">
              Planifier un call
            </button>
          </div>
        </div>

        <div className="bg-dark-4 bg-opacity-70 rounded-2xl p-6">
          <h4 className="text-lg font-semibold mb-3 font-sans">📞 Besoin d'aide immédiate ?</h4>
          <p className="text-light-3 mb-4 font-sans">
            Contactez-nous directement au <span className="text-white font-semibold">01 23 45 67 89</span><br />
            ou par email à <span className="text-white font-semibold">contact@littlemaker.fr</span>
          </p>
          <p className="text-light-3 text-sm font-sans">
            Du lundi au vendredi, 9h-18h
          </p>
        </div>
      </div>
    </section>
  );
};

export default FinalCallToAction;